module.exports = __webpack_public_path__ + "img/Tela docx2.754392bc.jpg";